import {
  hasNoSchedules,
  isNotArchived,
  isNotFrozen,
  isWithinDeadlineWindow,
} from '@griply/utils';
import { endOfDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useTasksQuery } from 'shared/hooks/queries/use-tasks-query';
import { useUser } from 'shared/hooks/use-user';

import { useActiveTasks } from './use-active-tasks';

export type Options = {
  uncompletedOnly?: boolean;
};

const defaultOptions: Options = {
  uncompletedOnly: true,
};

export const useTodaysTodos = ({ uncompletedOnly } = defaultOptions) => {
  const today = useToday();
  const user = useUser();
  const activeTasks = useActiveTasks();

  // Docs missing completedAt only surface through an unconstrained listener, so
  // the include-completed path keeps its own windowed query.
  const { data: withCompleted } = useTasksQuery(
    user?.uid,
    {
      deadlineStartDate: startOfDay(today),
      deadlineEndDate: endOfDay(today),
      uncompletedOnly,
      unFrozenOnly: true,
      noScheduleOnly: true,
    },
    !uncompletedOnly,
  );

  return useMemo(() => {
    if (!uncompletedOnly) {
      return withCompleted?.filter(isNotArchived) ?? [];
    }
    const start = startOfDay(today);
    const end = endOfDay(today);
    return activeTasks.filter(
      (task) =>
        isWithinDeadlineWindow(task, { start, end }) &&
        isNotFrozen(task) &&
        hasNoSchedules(task) &&
        isNotArchived(task),
    );
  }, [activeTasks, today, uncompletedOnly, withCompleted]);
};
